
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/expired-link",
      function () {
        return require("private-next-pages/expired-link.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/expired-link"])
      });
    }
  